<ng-container *transloco="let t">
  <section
    class="promo-banner"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="t('lang.promoBanner.ariaLabel')">
    <div class="promo-banner__card">
      <button
        type="button"
        class="promo-banner__close"
        [attr.aria-label]="t('lang.promoBanner.close')"
        (click)="emitCloseBanner()">
        <img [src]="closeIconUrl" alt="" aria-hidden="true" />
      </button>

      <div class="promo-banner__content promo-banner__content--mobile">
        <h2 class="promo-banner__title">
          <span>{{ t('lang.promoBanner.mobile.title.line1') }}</span>
          <span>{{ t('lang.promoBanner.mobile.title.line2') }}</span>
          <span class="promo-banner__title-highlight">{{
            t('lang.promoBanner.mobile.title.line3')
          }}</span>
          <span class="promo-banner__title-highlight">{{
            t('lang.promoBanner.mobile.title.line4')
          }}</span>
        </h2>

          <p class="promo-banner__body promo-banner__body--mobile">
            <span>{{ t('lang.promoBanner.body.prefix') }}</span>
            <strong>{{ t('lang.promoBanner.body.strong') }}</strong>
          </p>

          <button
            type="button"
            class="promo-banner__mobile-cta"
            (click)="emitCtaClick()">
            {{ t('lang.promoBanner.mobile.cta') }}
          </button>
      </div>
    </div>
  </section>
</ng-container>
